import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedGrid from './components/FeaturedGrid';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "CSSBuy Spreadsheet | Best CSSBuy Finds & Product Directory 2026",
            "description": "The most comprehensive CSSBuy Spreadsheet for 2026. Browse 15K+ verified product finds across 14 categories including Shoes, Hoodies, T-Shirts, Jackets, and Accessories. Updated weekly with fresh finds, trusted seller links, and QC references.",
            "url": `${siteUrl}/`,
            "speakable": {
              "@type": "SpeakableSpecification",
              "cssSelector": ["h1", "h2"]
            },
            "about": {
              "@type": "Thing",
              "name": "CSSBuy Spreadsheet"
            },
            "primaryImageOfPage": {
              "@type": "ImageObject",
              "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png"
            }
          })
        }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <CTASection />
      <AboutSection />
      <FeaturedGrid />
      <FeatureGrid />
      <TestimonialSection />
      <FAQSection />
      <Footer />
    </main>
  );
}